"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOAuthRcloneOptions = exports.isSharedDriveId = exports.OAUTH_CALLBACK_PATH = exports.isOAuthConnectionId = exports.OAUTH_CONNECTION_ID_FLOOR = exports.OAUTH_STORAGE_SCOPES = exports.OAUTH_STORAGE_LABELS = exports.OAUTH_STORAGE_PROVIDERS = void 0;
exports.OAUTH_STORAGE_PROVIDERS = [
    "drive",
    "dropbox",
];
exports.OAUTH_STORAGE_LABELS = {
    drive: "Google Drive",
    dropbox: "Dropbox",
};
exports.OAUTH_STORAGE_SCOPES = {
    drive: ["https://www.googleapis.com/auth/drive.readonly"],
    dropbox: ["files.metadata.read", "files.content.read", "account_info.read"],
};
exports.OAUTH_CONNECTION_ID_FLOOR = 1000000000;
const isOAuthConnectionId = (id) => Number.isSafeInteger(id) && id >= exports.OAUTH_CONNECTION_ID_FLOOR;
exports.isOAuthConnectionId = isOAuthConnectionId;
exports.OAUTH_CALLBACK_PATH = "/data/remote-storage/oauth/callback";
const SHARED_DRIVE_ID = /^[A-Za-z0-9_-]{1,128}$/;
const isSharedDriveId = (value) => SHARED_DRIVE_ID.test(value);
exports.isSharedDriveId = isSharedDriveId;
const CONTROL = /[\u0000-\u001f\u007f]/;
const toOAuthRcloneOptions = (input) => {
    if (!input.accessToken || CONTROL.test(input.accessToken)) {
        throw new Error("the access grant is not usable");
    }
    if (Number.isNaN(input.expiresAt.getTime())) {
        throw new Error("the access grant has no expiry");
    }
    const token = JSON.stringify({
        access_token: input.accessToken,
        token_type: "Bearer",
        expiry: input.expiresAt.toISOString(),
    });
    if ("dropbox" === input.provider) {
        return { type: "dropbox", token };
    }
    const options = {
        type: "drive",
        scope: "drive.readonly",
        token,
    };
    if (null !== input.sharedDriveId) {
        if (!(0, exports.isSharedDriveId)(input.sharedDriveId)) {
            throw new Error("the shared drive id is not usable");
        }
        options.team_drive = input.sharedDriveId;
    }
    return options;
};
exports.toOAuthRcloneOptions = toOAuthRcloneOptions;
